module.exports = __webpack_public_path__ + "img/home-icon-active.86b64a92.svg";